const anchors = document.querySelectorAll(".button, .language-link");
anchors.forEach((anchor) => {
  const content = anchor.innerHTML;
  const span = document.createElement("span");
  span.innerHTML = content;
  const span2 = span.cloneNode(true);
  anchor.innerHTML = "";
  anchor.appendChild(span);
  anchor.appendChild(span2);
});

const ajaxLinks = document.querySelectorAll("[data-ajax-link]");
const lightbox = document.querySelector("[data-ajax-lightbox]");
const close = document.querySelector("[data-ajax-close]");

if (close) {
  close.addEventListener("click", (e) => {
    e.preventDefault();
    lightbox.classList.remove("is-active");
    document.body.style.overflow = "auto";
  });
}

ajaxLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();
    const href = link.getAttribute("href");
    fetch(href, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, "text/html");
        const newContent = newDocument.querySelector("[data-ajax-content]");
        const container = document.querySelector("[data-ajax-container]");
        container.innerHTML = newContent.innerHTML;
        lightbox.classList.add("is-active");
        document.body.style.overflow = "hidden";
      });
  });
});

const nav = document.querySelector("[data-nav]");
const sticky = document.querySelector("[data-sticky]");
let isSticky = false;

if (nav) {
  window.addEventListener("scroll", () => {
    const navRect = nav.getBoundingClientRect();
    if (navRect.top < 0) {
      if (!isSticky) {
        sticky.classList.add("is-active");
        isSticky = true;
      }
    } else {
      if (isSticky) {
        sticky.classList.remove("is-active");
        isSticky = false;
      }
    }
  });
}

const scrollLinks = document.querySelectorAll("[data-scrollto]");
const burgerDropdown = document.querySelector("[data-burger-dropdown]");

scrollLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();
    lightbox.classList.remove("is-active");
    const href = link.getAttribute("href");
    const target = document.querySelector(href);
    const targetTop = target.getBoundingClientRect().top;
    const offset = targetTop - 150;
    window.scrollBy({
      top: offset,
      behavior: "smooth",
    });
    burgerTrigger.classList.remove("is-active");
    burgerDropdown.classList.remove("is-active");
    document.body.style.overflow = "auto";
  });
});

const sections = document.querySelectorAll("[data-section]");
const links = document.querySelectorAll("[data-scrollto]");

window.addEventListener("scroll", () => {
  sections.forEach((section) => {
    const sectionTop = section.getBoundingClientRect().top;
    if (sectionTop < 600) {
      const id = section.getAttribute("id");
      links.forEach((link) => {
        link.classList.remove("is-active");
        if (link.getAttribute("href") === `#${id}`) {
          link.classList.add("is-active");
        }
      });
    }
  });
});

const topbar = document.querySelector("[data-topbar]");
let lastScrollTop = 0;
window.addEventListener("scroll", () => {
  const scrollTop = window.scrollY;
  if (scrollTop > lastScrollTop) {
    topbar.classList.remove("is-fixed");
    document.body.style.paddingTop = "0";
  } else {
    if (window.innerWidth > 968) return;
    topbar.classList.add("is-fixed");
    document.body.style.paddingTop = topbar.offsetHeight + "px";
  }
  lastScrollTop = scrollTop;
});

const burgerTrigger = document.querySelector("[data-burger-trigger]");

burgerTrigger.addEventListener("click", (e) => {
  e.preventDefault();
  burgerTrigger.classList.toggle("is-active");
  burgerDropdown.classList.toggle("is-active");
  if (burgerDropdown.classList.contains("is-active")) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
});

const ratio = window.devicePixelRatio;
const font = new FontFace(
  "Bai Jamjuree",
  "url(https://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa0gebelJo02SuCgQ.woff2)"
);

function createCanvas(wrapper) {
  const canvas = document.createElement("canvas");
  wrapper.innerHTML = "";
  wrapper.appendChild(canvas);

  const width = wrapper.offsetWidth;
  const height = wrapper.offsetHeight;
  const text = wrapper.getAttribute("data-text") + " ";

  canvas.width = width * ratio;
  canvas.height = height * ratio;
  canvas.style.width = width + "px";
  canvas.style.height = height + "px";

  var ctx = canvas.getContext("2d");
  ctx.scale(ratio, ratio);
  ctx.font = "229px Bai Jamjuree";
  ctx.fillStyle = "#132B3E";

  const textWidth = ctx.measureText(text).width;
  const numberOfText = Math.ceil(width / textWidth) + 1;
  const textToRender = text.repeat(numberOfText);
  ctx.fillText(textToRender, 0, 200);

  let x = 0;

  const animate = () => {
    requestAnimationFrame(animate);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillText(textToRender, x, 200);
    x -= 0.5;
    if (x < -textWidth) {
      x = 0;
    }
  };

  animate();
}

font.load().then((font) => {
  document.fonts.add(font);

  const canvasWrapper = document.querySelectorAll("[data-text]");

  canvasWrapper.forEach((wrapper) => {
    const canvas = document.createElement("canvas");
    wrapper.appendChild(canvas);

    createCanvas(wrapper);

    window.addEventListener("resize", () => {
      createCanvas(wrapper);
    });
  });
});
